import {
  DataTable,
  FormInput,
  FormSelect,
  Heading,
  Loader,
} from "@/components";
import useInvoiceListing from "./useListing";
import { FormProvider } from "react-hook-form";
import {
  DOCUMENT_TYPE,
  parkDocumentSearch,
  postDocumentSearch,
  SEARCH_CRITERIA,
  SEARCH_TYPE,
  searchType,
} from "./consts";
import { Button } from "@/components/ui";

const Listing = () => {
  const {
    breadcrumbData,
    columns,
    globalFilter,
    setGlobalFilter,
    onRowClick,
    isDocLoading,
    documentList,
    setPageNumber,
    setPageSize,
    pageNumber,
    pageSize,
    sorting,
    setSorting,
    isDocRefetching,
    form,
    onSubmit,
    onClear,
    isPosted,
    documentTypeList,
    isListLoading,
  } = useInvoiceListing();
  const { errors } = form.formState;

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col xl:flex-row gap-2 xl:items-center xl:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={breadcrumbData[breadcrumbData?.length - 1]?.name || ""}
            breadcrumbData={breadcrumbData}
          />
        </div>
      </div>

      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px] mb-[30px]">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
              <FormSelect
                name={DOCUMENT_TYPE}
                control={form.control}
                label="Document Type"
                placeholder="Please select"
                options={documentTypeList?.map((data: any) => ({
                  label: `${data?.documentType} - ${data?.documentTypeDisplayName}`,
                  value: data?.documentTypeId?.toString(),
                }))}
                disabled={isListLoading}
              />
              <FormSelect
                name={SEARCH_TYPE}
                control={form.control}
                label="Search Type"
                placeholder="Please select"
                error={errors[SEARCH_TYPE]?.message}
                options={
                  isPosted
                    ? [...postDocumentSearch, ...searchType]
                    : [...parkDocumentSearch, ...searchType]
                }
                disabled={isListLoading}
              />
              <FormInput
                name={SEARCH_CRITERIA}
                control={form.control}
                label="Search Criteria"
                placeholder="Please enter"
                error={errors[SEARCH_CRITERIA]?.message}
                disabled={isListLoading}
              />
              <div className="flex flex-row justify-end gap-3 pt-3">
                <Button type="submit" disabled={isListLoading}>Search</Button>
                <Button variant="outline" type="button" onClick={onClear} disabled={isListLoading}>
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>

      {/* Responsive Table */}
      {isDocLoading || isDocRefetching ? (
        <Loader />
      ) : (
        <>
          <DataTable
            columns={columns}
            data={documentList?.data || []}
            setGlobalFilter={setGlobalFilter}
            globalFilter={globalFilter}
            onRowClick={onRowClick}
            setPageNumber={setPageNumber}
            setPageSize={setPageSize}
            pageNumber={pageNumber}
            pageSize={pageSize}
            totalPages={Math.ceil(documentList?.total / pageSize)}
            totalRecords={documentList?.total}
            serverSidePagination={true}
            sorting={sorting}
            onSortingChange={setSorting}
          />
        </>
      )}
    </div>
  );
};

export default Listing;
